import React, { useEffect, useState } from "react";
import axios from "axios";
const DuesModal = ({ totalDues, setOpenDuesModal, currentCheckIn }) => {
  const [paymentAmount, setPaymentAmount] = useState("");
  const [actualAmount, setActualAmount] = useState(0);
  const [leftOver, setLeftOver] = useState(0);
  const [showText, setShowText] = useState(false);
  const [load, setLoad] = useState(false);

  const updateDues = (id) => {
    setLoad(true);
    const charge = currentCheckIn?.dueCarryOver - paymentAmount;
    let status;
    if (leftOver == 0) {
      status = "Cleared";
    } else {
      status = currentCheckIn?.paymentStatus;
    }

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/update_check_in/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        paymentStatus: status,
        dueCarryOver: leftOver,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setOpenDuesModal(false);
        setLoad(false);
      })
      .catch((error) => {
        console.log(error);
        setLoad(false);
      });
  };
  console.log(leftOver);
  useEffect(() => {
    console.log("I am running");
    const dues = currentCheckIn?.dueCarryOver - paymentAmount;
    setLeftOver(dues);
  }, [paymentAmount]);

  return (
    <div className="flex items-center justify-center z-50  fixed inset-0 min-h-screen bg-[black]/10 backdrop-blur-sm p-4">
      <div className="bg-white relative  p-2  rounded-2xl shadow-2xl max-w-3xl">
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-4">Collect Payment</h2>
          <p className="mb-4">
            Enter the amount you wish to pay towards your dues.
          </p>
          <div className="mb-4">
            <label
              htmlFor="totalDues"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Total Dues
            </label>
            <div className="text-lg font-semibold">
              Rs.{currentCheckIn?.dueCarryOver} ({currentCheckIn?.paymentStatus}
              )
            </div>
          </div>
          <div className="mb-4">
            <label
              htmlFor="payAmount"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Pay Amount
            </label>
            <input
              id="payAmount"
              type="number"
              placeholder="Enter amount"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={paymentAmount}
              onFocus={() => {
                setShowText(true);
              }}
              onChange={(e) => setPaymentAmount(e.target.value)}
            />
          </div>
          {showText && (
            <span class="text-red-500 text-sm font-semibold my-1">
              Left Over Amount is Rs.{leftOver}.
            </span>
          )}
        </div>
        <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-4 rounded-b-lg">
          <button
            onClick={() => {
              setOpenDuesModal(false);
            }}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              updateDues(currentCheckIn._id);
            }}
            className="px-4 py-2 bg-primaryBtnColor hover:bg-primaryBtnHoverColor border border-transparent rounded-md text-lg tracking-wide font-medium text-white focus:outline-none focus:ring-2 "
          >
            {load ? "Please Wait..." : "Collect Payment"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuesModal;
